import type { Plugin } from "vue";

export default {
  install(app) {
    app.config.globalProperties.pluralize = pluralize;
  },
} as Plugin;

declare module "vue" {
  interface ComponentCustomProperties {
    pluralize: typeof pluralize;
  }
}
